import type { ThemeSlots } from "../../types";

/**
 * B2C slot overrides. Empty — B2C is a token-only theme.
 */
export const slots: ThemeSlots = {};
